/**
 * Class on the root of the icon-only buttons in @tix-ticketing/ui-components.
 * They render a MUI Button, so theme selectors that target `.MuiButton-root`
 * use it to tell icon buttons apart from text buttons.
 */
export const iconButtonClassName = 'TixIconButton-root';